import Vue from '../../lib/utils/vue'
import { styled } from '@egoist/vue-emotion'
import { VueEmotion } from '@egoist/vue-emotion'
import { CvtIcon } from './icon/icon'
import CvtButton from './Button'
import * as getters from "../../../builder/src/js/store/modules/getters"
import { mapGetters, mapState } from '../../../builder/node_modules/vuex'

Vue.use(VueEmotion)

let Spacing, Radii, Border
let textFontWeight, borderColor, backgroundColor, textFontSize, textColor

const getNotificationBox = () => styled('div')`
  flex-direction: column;
  height: 76px;
  min-height: 76px;
  width: 300px;
  position:fixed;
  z-index:1000;
  margin-bottom: ${Spacing.SPACING_12}px;
  padding: ${Spacing.SPACING_12}px;
  border: ${Border.SIZE_1}px solid transparent;
  border-radius: ${Radii.RADIUS_PX_8}px;
  ${(props) => {

    let styles = ``
    if (props.mode === 'LIGHT') {
      styles += backgroundColor({ themeing: 'dark' }, 'WHITE')
    } else if (props.mode === 'DARK') {
      styles += backgroundColor({ themeing: 'dark' }, 700)
    } else {
      styles += backgroundColor(props, 100)
    }
    styles += borderColor(props, 300)
    let offset = parseInt(props.offsetValue) + parseInt(props.intialOffsetValue)
    if (props.position === 'top-left') {
      styles += "top:" + offset + "px;"
      styles += "left:0px;"
    }
    else if (props.position === 'bottom-right') {
      styles += "bottom:" + offset + "px;"
      styles += "right:0px;"
    }
    else if (props.position === 'bottom-left') {
      styles += "bottom:" + offset + "px;"
      styles += "left:0px;"
    }
    else {
      styles += "top:" + offset + "px;"
      styles += "right:0px;"
    }
    return styles
  }}
`
const getWarningIcon = () => styled(CvtIcon)`
  ${textFontSize('xl')}
  margin-top: ${Spacing.SPACING_4}px;
  ${(props) => textColor(props, 400)}
`

const getCloseButtonWrapper = () => styled('div')`
  color: gray;
  cursor: pointer;
`
const getNotificationTitle = () => styled('div')`
  padding: 0 ${Spacing.SPACING_12}px;
  flex: 90%
`
const getNotificationTitleMsg = () => styled('p')`
  ${textFontWeight('LARGE')}
  margin: 0;
  ${textFontSize('xl')}
  ${(props) =>
    props.mode === 'DARK'
      ? textColor({ themeing: 'dark' }, 100)
      : textColor(props, 700)}
`
const getNotificationMsg = () => styled('div')`
  flex:90%;
  word-break: break-word;
  ${textFontWeight('REGULAR')}
  margin-left: ${Spacing.SPACING_16}px;
  ${textFontSize('sm')}
  ${(props) =>
    props.mode === 'DARK'
      ? textColor({ themeing: 'dark' }, 100)
      : textColor(props, 700)}
`

const getActionAnchor = () => styled('a')`
  ${textFontSize('sm')}
  cursor: pointer;
  padding: 5px 0 0;
  flex:10%;
  ${(props) =>
    props.mode === 'DARK'
      ? textColor({ themeing: 'dark' }, 100)
      : textColor(props, 700)}
  ${(props) => {
    let styles = ``
    styles += props.mode === 'DARK' ? textColor(props, 400) : textColor(props, 700)
    styles += `
      &:hover {
        ${props.mode === 'DARK' ? textColor(props, 100) : textColor(props, 700)}
      }
    `
    return styles
  }}
`
const getNotificationContentWrap = () => styled('div')`
display:flex;
`
export default Vue.extend({
  name: 'NotificationElement',
  components: {
    CvtIcon
  },
  beforeDestroy () {
  },
  computed: {
    ...mapGetters('globalTheme', {
      textFontWeight: getters.GLOBAL_STYLE_FONT_WEIGHT,
      textColor: getters.GLOBAL_STYLE_COLOR,
      borderColor: getters.GLOBAL_STYLE_BORDER_COLOR,
      backgroundColor: getters.GLOBAL_STYLE_BACKGROUND_COLOR,
      textFontSize: getters.GLOBAL_STYLE_FONT_SIZE
    }),
    ...mapState('globalTheme', {
      Spacing: ({ globalTheme }) => globalTheme.Spacing,
      Radii: ({ globalTheme }) => globalTheme.Radii,
      Border: ({ globalTheme }) => globalTheme.Border
    })
  },
  props: {
    duration: {
      type: Number,
      default: 4500
    },
    mode: {
      type: String,
      default: 'LIGHT'
    },
    position: {
      type: String,
      default: 'top-right'
    },
    offsetValue: {
      type: Number,
      default: 0
    },
    intialOffsetValue: {
      type: Number,
      default: 0
    },
    closeIcon: {
      type: Boolean,
      default: false
    },
    closeAction: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'info'
    },
    id: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    actionName: {
      type: String,
      default: 'action'
    },
  },
  data () {
    return {
      visible: false,
    }
  },
  methods: {
    close () {
      this.visible = false
      this.$emit("notificationClosed", this.id)
    },
    actionOnClick () {
      this.$emit("action", this.id)
    }
  },
  created () {
    Spacing = this.Spacing
    Radii = this.Radii
    Border = this.Border

    textFontWeight = this.textFontWeight
    borderColor = this.borderColor
    textColor = this.textColor
    backgroundColor = this.backgroundColor
    textFontSize = this.textFontSize
    this.visible = true
    if (this.duration > 0) {
      this.timer = setTimeout(() => {
        if (this.visible) {
          this.close();
        }
      }, this.duration);
    }
  },
  destroyed () {
  },
  render: function (h) {
    const NotificationBox = getNotificationBox()
    const WarningIcon = getWarningIcon()
    const CloseButtonWrapper = getCloseButtonWrapper()
    const NotificationTitle = getNotificationTitle()
    const NotificationTitleMsg = getNotificationTitleMsg()
    const NotificationMsg = getNotificationMsg()
    const ActionAnchor = getActionAnchor()
    const NotificationContentWrap = getNotificationContentWrap()
    return (
      <div>
        <NotificationBox
          mode={this.mode}
          offsetValue={this.offsetValue}
          position={this.position}
          intialOffsetValue={this.intialOffsetValue}
        >
          <NotificationContentWrap>
            <WarningIcon
              icon={this.icon}
              hover
            ></WarningIcon>
            <NotificationTitle>
              <NotificationTitleMsg mode={this.mode}>
                {this.title}
              </NotificationTitleMsg>
            </NotificationTitle>

            {this.closeIcon && (
              <CloseButtonWrapper>
                <CvtButton
                  shape='pill'
                  size='xs'
                  icon='times'
                  disabled={false}
                  actionIcon={true}
                  onClick={this.close}
                  colorOfActionIcon={
                    this.mode === 'DARK' ? '' : this.color
                  }
                  modeOfActionIcon={
                    this.mode === 'DARK' ? 'LIGHT' : 'DARK'
                  }
                ></CvtButton>
              </CloseButtonWrapper>
            )}
          </NotificationContentWrap>
          <NotificationContentWrap>
            <NotificationMsg mode={this.mode}>
              {this.message}
            </NotificationMsg>

            {this.closeAction && (
              <ActionAnchor
                onClick={this.actionOnClick}
                mode={this.mode}>
                {this.actionName}
              </ActionAnchor>
            )}
          </NotificationContentWrap>
        </NotificationBox>
      </div>
    )
  }
})